import * as React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import * as SalesforceRecordActions from '../../actions/salesforceRecords';
import { useEffect } from 'react';

export const DisposableAlert = ({ child, disposeFunction, timeout }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const timeId = setTimeout(() => {
      disposeFunction(false);
      dispatch(SalesforceRecordActions.setSalesforceRecordRedirectLink(''));
      dispatch(SalesforceRecordActions.setSalesforceRecordTooltipContent(''));
    }, timeout);
    return () => {
      clearTimeout(timeId);
    };
  });
  return (
    < >
      {child}
    </>
  );
};

DisposableAlert.propTypes = {
  child: PropTypes.object,
  disposeFunction: PropTypes.func,
  timeout: PropTypes.number,
};
